"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _StringValue = _interopRequireDefault(require("./StringValue"));

var _NumberValue = _interopRequireDefault(require("./NumberValue"));

var _SelectValue = _interopRequireDefault(require("./SelectValue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Value =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Value, _React$Component);

  function Value() {
    _classCallCheck(this, Value);

    return _possibleConstructorReturn(this, _getPrototypeOf(Value).apply(this, arguments));
  }

  _createClass(Value, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          operator = _this$props.operator,
          field = _this$props.field,
          dataConnector = _this$props.dataConnector,
          getDataConnectorMeta = _this$props.getDataConnectorMeta;

      if (!operator || !operator.isValue) {
        return null;
      }

      if (operator.valueType === 'string') {
        return _react.default.createElement(_StringValue.default, {
          field: field
        });
      }

      if (operator.valueType === 'number') {
        return _react.default.createElement(_NumberValue.default, {
          field: field
        });
      }

      if (operator.valueType === 'select') {
        var meta = getDataConnectorMeta(dataConnector);
        return _react.default.createElement(_SelectValue.default, {
          field: field,
          possibleValues: meta && meta.possibleValues
        });
      }

      return null;
    }
  }]);

  return Value;
}(_react.default.Component);

exports.default = Value;

_defineProperty(Value, "propTypes", {
  operator: _propTypes.default.object,
  field: _propTypes.default.object,
  dataConnector: _propTypes.default.object,
  getDataConnectorMeta: _propTypes.default.func
});